import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";

import { Breadcrumbs, ScreenContent, ScreenHeader, TabNavigation } from "@/ui";

const TABS = [
  { name: "Overview", to: "/integrations/personify/overview" },
  { name: "Identities", to: "/integrations/personify/identities" },
  { name: "Rewards", to: "/integrations/personify/rewards" },
  { name: "OIDC Events", to: "/integrations/personify/events" },
] as const;

const PersonifyLayout = () => {
  const { id } = useParams({ strict: false });

  return (
    <>
      <ScreenHeader>
        <Breadcrumbs
          items={[
            { label: "Integrations", to: "/integrations" },
            { label: "Personify", to: "/integrations/personify/overview" },
            ...(id
              ? [
                  {
                    label: `#${id}`,
                    to: "/integrations/personify/identities/$id",
                    params: { id },
                  } as const,
                ]
              : []),
          ]}
        />
      </ScreenHeader>

      <ScreenContent>
        <TabNavigation tabs={[...TABS]} />

        <div className="pt-4">
          <Outlet />
        </div>
      </ScreenContent>
    </>
  );
};

export const Route = createFileRoute("/_private/integrations/personify")({
  component: PersonifyLayout,
});
